import Draggable from 'react-draggable';
import anchorImg from '../../shared/assets/images/anchor_help.svg';
import './DraggableAnchor';
import { useDispatch } from 'react-redux';
import { setAnchorPosition, setIsAnchorFalse } from '../../shared/redux/hooks/slice';

const DraggableAnchor = () => {
  const dispatch = useDispatch();
  const onDrag = (ev: any) => {
    var rect = ev.target.getBoundingClientRect();
    dispatch(
      setAnchorPosition({
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
      }),
    );
    dispatch(setIsAnchorFalse());
  };

  return (
    <Draggable
      handle=".handle"
      defaultPosition={{ x: 0, y: 0 }}
      scale={1}
      onStop={(ev) => onDrag(ev)}>
      <div className="handle">
        <img
          onMouseDown={(ev) => ev.preventDefault()}
          src={anchorImg}
          onClick={(ev) => {
            ev.preventDefault();
          }}
        />
      </div>
    </Draggable>
  );
};

export default DraggableAnchor;
